import { useNavigate } from 'react-router-dom';
import BaseImage from '../../components/base/base-image';
import InternalServerLogo from '../../assets/images/internal-server.png';
import React from 'react';
import AppButton from '../../components/base/button';
import AuthFooter from '../../layout/component/auth-footer';

const InternalServer: React.FC = () => {
  const navigate = useNavigate();

  const gotoDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white email-verified-bg w-full relative">
      <div className="absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 max-h-[50vh]">
        <div className="max-w-md p-6 bg-transparent text-center">
          <div className="flex justify-center mb-4">
            <BaseImage
              imgSrc={InternalServerLogo}
              imgAlt={'Internal server'}
              imgClass="mb-4 w-60"
            />
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-6">
            Internal Server Error
          </h1>
          <p className="text-[#383838] mb-6">
            The server encountered an unexpected condition that prevented it
            from fulfilling your request.
          </p>
          <div className="flex items-center gap-6">
            <AppButton
              label="Back to Dashboard"
              type={'dark'}
              clicked={gotoDashboard}
            />
          </div>
        </div>
      </div>

      <AuthFooter />
    </div>
  );
};

export default InternalServer;
